import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import ReactTooltip from 'react-tooltip';
import { getShortSummary } from '../../utils/timeline';
import { groupEventsWithCount } from '../../utils/groupEventsWithCount';

type Props = {
  item: any;
  children: ReactNode;
};

const ItemWithTooltip: React.FC<Props> = ({ item, children }) => {
  const countMap = groupEventsWithCount(item?.children || []);
  if (countMap && Array.from(countMap).length > 1) {
    return children;
  }
  return (
    <div data-tip data-for={'item-' + item.id}>
      {children}
      {ReactDOM.createPortal(
        <ReactTooltip id={'item-' + item.id} className="timeline-tooltip">
          <span>{getShortSummary(item, countMap)}</span>
        </ReactTooltip>,
        document.body,
      )}
    </div>
  );
};

export default ItemWithTooltip;
